import { TechInsightsPage } from '@mercedes-benz/tech-insights';

export const TechInsightsTab = () => <TechInsightsPage />;
